/* Only the care guide's own index; no network, tracking or commerce hooks. */
(function(){'use strict';
var root=document.querySelector('[data-oh-contact-care]');if(!root||root.dataset.navigationReady)return;root.dataset.navigationReady='true';
root.addEventListener('click',function(event){
 var link=event.target.closest('.cg-nav a[href^="#cg-"]');if(!link||!root.contains(link)||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
 var target=root.querySelector(link.getAttribute('href'));if(!target)return;
 event.preventDefault();event.stopPropagation();if(location.hash!==link.hash)history.pushState(null,'',link.hash);
 target.focus({preventScroll:true});target.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'auto'});
});
})();
